import { FileText, Loader2, Trash2 } from 'lucide-react';
import type { Artifact } from '@ideoz/core';
import { artifactTitle } from '../artifactMappers';

interface ArtifactRowProps {
  artifact: Artifact;
  isDeleting: boolean;
  onOpen: () => void;
  onDelete: (id: string) => void;
}

/** Dumb: a single artifact row — opens the panel on click, deletes on the icon. */
export function ArtifactRow({
  artifact,
  isDeleting,
  onOpen,
  onDelete,
}: ArtifactRowProps): JSX.Element {
  const name = artifactTitle(artifact);

  return (
    <li
      className="flex items-center gap-3 px-4 py-3 hover:bg-gray-50 dark:hover:bg-gray-750 cursor-pointer"
      onClick={onOpen}
    >
      <FileText className="w-5 h-5 text-primary-500 shrink-0" />
      <div className="flex-1 min-w-0">
        <p className="text-sm text-gray-800 dark:text-gray-100 truncate">{name}</p>
        {artifact.createdAt && (
          <p className="text-xs text-gray-400 dark:text-gray-500">
            {new Date(artifact.createdAt).toLocaleString()}
          </p>
        )}
      </div>
      {/* <button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          onDelete(artifact.id);
        }}
        disabled={isDeleting}
        className="text-gray-400 dark:text-gray-500 hover:text-red-500 dark:hover:text-red-400 transition-colors disabled:opacity-50"
        aria-label={`Delete ${name}`}
      >
        {isDeleting ? <Loader2 className="w-4 h-4 animate-spin" /> : <Trash2 className="w-4 h-4" />}
      </button> */}
    </li>
  );
}
